import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorsService } from 'src/app/core/services/validators/validators.service';
import { AdminClientService } from '../../../../core/http/admin-client.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
	user_email = '';
	tMsg: string = '';
	typeMsg: string = '';
	removeMsg: boolean = true;
	styles_input: string = '';
	styles_message: string = '';
	sub_domain: string = '';
	data;
	version: string;
	//Esto permite que el invalid tooltip no se muestre al inicio
	submitted = false;
	emailValidado: boolean = false;
	formularioForgot: FormGroup = this.fb.group({
		email: [
			'',
			[
				Validators.required,
				Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
			]
		],
	});
	btnDisabled:boolean=false;
	get emailValidation() {
		this.user_email = this.formularioForgot.get('email').value;
		return this.formularioForgot.get('email');
	}
	constructor(
		private fb: FormBuilder,
		private vs: ValidatorsService,
		private adminService: AdminClientService,
		private toastr: ToastrService
	) {
		this.sub_domain = localStorage.getItem('sub_domain');
		this.version = localStorage.getItem('version');
	}
	validate() {
		this.removeMsg = true;
		if (this.formularioForgot.valid) {
			this.emailValidado = true;
			this.submitted = false;
		} else {
			this.emailValidado = false;
			this.submitted = true;
		}

		if (this.emailValidation.value === '') {
			this.mostrarErrorEmailVacio();
		} else {
			this.data = {
				language: localStorage.getItem('language'),
				email_send: this.emailValidation.value,
			};
			this.adminService.post_forgot_password_user(this.data).subscribe((res) => {
				if (res.mensaje_return.CODE === 200) {
					this.cambioPasswordExitoso();
				}
				else {
					if (res.mensaje_return.CODE == 1102) {
						this.mostrarErrorEmail();

					}
					if (res.mensaje_return.CODE == 1203) {
						this.mostrarErrorEmailVacio();

					}
				}
			});
		}
	}
	errorCount = 0;
	cambioPasswordExitoso(){
		if (this.errorCount < 3) {
			this.toastr.success('para restablecer tu contraseña', 'Te enviamos un correo con las instrucciones', {
				toastClass: 'toast-extendida',
				timeOut: 30000,
				positionClass: 'toast-bottom-left',
				progressBar:true,
				progressAnimation:'decreasing',
				onActivateTick:true
			});
			this.errorCount = 3
			this.btnDisabled = true;
		}
		setTimeout(() => {
			this.btnDisabled = false;
			this.errorCount = 0
		}, 30000);
	}

	mostrarErrorEmail(){
		if (this.errorCount < 3) {
			this.toastr.error('Revisa que tenga +3 caracteres, un "@" y un ".com"', 'Ingresa un correo valido', {
				toastClass: 'toast-erronea',
				timeOut: 5000,
				positionClass: 'toast-bottom-left',
			});
			this.errorCount++;
		}
		else if (this.errorCount === 3) {
			this.toastr.error('Intenta de nuevo en 30 segundos', 'Has sobrepasado el limite de intentos', {
				toastClass: 'toast-erronea',
				timeOut: 30000,
				positionClass: 'toast-bottom-left',
				progressBar:true
			});
			this.errorCount++;
			this.btnDisabled = true;
			setTimeout(() => {
				this.btnDisabled = false;
				this.errorCount = 0;
			}, 30000); // Reiniciar el contador a 0 después de 5 segundos
		}
	}
	mostrarErrorEmailVacio(){
		if (this.errorCount < 3) {
			this.toastr.error('Completalo e intentalo de nuevo', 'Este campo es requerido', {
				toastClass: 'toast-erronea',
				timeOut: 5000,
				positionClass: 'toast-bottom-left',
			});
			this.errorCount++;
		}
		else if (this.errorCount === 3) {
			this.toastr.error('Intenta de nuevo en 30 segundos', 'Has sobrepasado el limite de intentos', {
				toastClass: 'toast-erronea',
				timeOut: 30000,
				positionClass: 'toast-bottom-left',
				progressBar:true
			});
			this.errorCount++;
			this.btnDisabled = true;
			setTimeout(() => {
				this.btnDisabled = false;
				this.errorCount = 0;
			}, 30000); // Reiniciar el contador a 0 después de 5 segundos
		}
	}
}
